export default __webpack_public_path__ + "35594ddca77b00eac3d5f639fe6ab915.svg";